/** Runtime credentials for the globally configured browser trace exporter. */

const PUBLIC_INTERVIEW_PATH = /^\/interview\/[^/]+\/?$/;
const INTERVIEW_SCOPE_HEADER = "X-Lato-Interview-Scope-Token";

let activeInterviewProof: { pathname: string; token: string } | null = null;

/**
 * Retain a public interview's signed proof for this route's page lifetime. A render crash unmounts
 * the room before Logfire's batch exporter runs, so component cleanup must not revoke the proof.
 * A later room replaces it; `setClientTraceRoute` revokes it when navigation genuinely leaves.
 */
export function registerPublicInterviewTraceToken(token: string, pathname: string): void {
  activeInterviewProof = { pathname, token };
}

/** Revoke a retained interview proof only after the browser has genuinely changed routes. */
export function setClientTraceRoute(pathname: string): void {
  if (activeInterviewProof?.pathname !== pathname) activeInterviewProof = null;
}

/** Resolve exporter headers at send time, after route info and auth restoration have settled. */
export function clientTraceHeaders(
  pathname: string,
  accessToken: string | null
): Record<string, string> {
  setClientTraceRoute(pathname);
  if (PUBLIC_INTERVIEW_PATH.test(pathname)) {
    return activeInterviewProof
      ? { [INTERVIEW_SCOPE_HEADER]: activeInterviewProof.token }
      : {};
  }
  return accessToken ? { Authorization: `Bearer ${accessToken}` } : {};
}
